// extracted by mini-css-extract-plugin
export var fadeIn = "_mf-1";
export var modalContent = "_mf-3";
export var overlay = "_mf-0";
export var popoverContent = "_mf-2";
export var results = "_mf-5";
export var searchInputWrapper = "_mf-4";